import { Action, createReducer, on } from '@ngrx/store';
import { 
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState
} from './payments-batch.action';
import { PaymentsBatch } from './payments-batch.model';

export interface PaymentsBatchRecordsState {
    listData: PaymentsBatch[];
    singleData: PaymentsBatch;
    loading: boolean;
    error: any;
    total: number;
}

export const initialState: PaymentsBatchRecordsState = {
    listData: [],
    singleData: null,
    loading: false,
    error: null,
    total: 0
};


export const PaymentsBatchRecordReducer = createReducer(

    initialState,
    
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),
    
    on(resetState, () => initialState)  // Reset action handler
    
);